var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-trash",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconB-trash1",
    serifid: "iconB-trash"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7,5.5c0.007,-1.232 0.075,-1.867 0.327,-2.362c0.288,-0.564 0.747,-1.023 1.311,-1.311c0.521,-0.266 1.197,-0.327 2.562,-0.327l1.6,0c1.365,0 2.041,0.061 2.562,0.327c0.564,0.288 1.023,0.747 1.311,1.311c0.252,0.495 0.32,1.13 0.327,2.362l4,0c0.552,0 1,0.448 1,1c0,0.552 -0.448,1 -1,1l-1,0l0,9.2c0,1.925 -0.061,2.881 -0.436,3.616c-0.383,0.753 -0.995,1.365 -1.748,1.748c-0.735,0.375 -1.691,0.436 -3.616,0.436l-4.4,-0c-1.925,-0 -2.881,-0.061 -3.616,-0.436c-0.753,-0.383 -1.365,-0.995 -1.748,-1.748c-0.375,-0.735 -0.436,-1.691 -0.436,-3.616l0,-9.2l-1,-0c-0.552,-0 -1,-0.448 -1,-1c0,-0.552 0.448,-1 1,-1l4,-0Zm11,2l-12,-0l0,9.2c0,1.436 -0.061,2.159 0.218,2.708c0.192,0.376 0.498,0.682 0.874,0.874c0.548,0.279 1.272,0.218 2.708,0.218l4.4,0c1.436,0 2.16,0.061 2.708,-0.218c0.376,-0.192 0.682,-0.498 0.874,-0.874c0.279,-0.548 0.218,-1.272 0.218,-2.708l0,-9.2Zm-9.001,-2l6.002,-0c0.007,-0.746 0.047,-1.146 -0.11,-1.454c-0.096,-0.188 -0.249,-0.341 -0.437,-0.437c-0.335,-0.171 -0.778,-0.109 -1.654,-0.109l-1.6,-0c-0.876,-0 -1.319,-0.062 -1.654,0.109c-0.188,0.096 -0.341,0.249 -0.437,0.437c-0.157,0.308 -0.117,0.708 -0.11,1.454Zm4.001,6.5c-0,-0.552 0.448,-1 1,-1c0.552,-0 1,0.448 1,1l-0,5c-0,0.552 -0.448,0 -1,0c-0.552,0 -1,0.552 -1,0l-0,-5Zm-4,0c-0,-0.552 0.448,-1 1,-1c0.552,0 1,0.448 1,1l-0,5c-0,0.552 -0.448,0 -1,0c-0.552,0 -1,0.552 -1,0l-0,-5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBTrash);
export default __webpack_public_path__ + "static/media/iconB-trash.6c31d40da83fa7e85ae3d05bd538c1bc.svg";
export { ForwardRef as ReactComponent };